<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <div class="search-left">
                    <el-select v-model="query.news_type" placeholder="订单类型" class="handle-input mr10">
                        <el-option v-for="item in planNewsTypeList" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="query.status" placeholder="派单状态" filterable clearable class="handle-input mr10">
                        <el-option v-for="(item, index) in statusList" :key="index" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                    <el-select v-model="query.company_id" placeholder="婚庆执行公司" filterable clearable class="handle-input mr10">
                        <el-option v-for="(item, index) in dictionary.getPicker('company')" :key="index" :label="item.title" :value="item.id+''"></el-option>
                    </el-select>
                    <el-date-picker class="daterange mr10" v-model="query.date_range" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    <el-select v-model="query.hotel_id" placeholder="举办酒店" class="handle-input mr10" filterable clearable>
                        <el-option v-for="(item, index) in dictionary.getPicker('hotel')" :key="index" :label="item.title" :value="item.id+''"></el-option>
                    </el-select>
                    <el-select v-model="query.planer_id" placeholder="请选择策划师" class="handle-input mr10" filterable clearable>
                        <el-option v-for="(item, index) in plannerList" :key="index" :label="item.realname" :value="item.id"></el-option>
                    </el-select>
                    <el-input v-model="query.keywords" placeholder="手机号/客户姓名/微信号" clearable class="handle-input mr10"></el-input>
                    <el-button type="primary" class="btn-search ml8" @click="changeHandler">搜索</el-button>
                    <el-popover placement="bottom" width="600" trigger="click">
                        <div class="help-container">
                            <div>
                                <el-tag type="danger">工程单状态</el-tag>
                                <dl class="help-box">
                                    <dt class="w150">待派发:</dt>
                                    <dd>派发某摄影师/化妆师/司仪/摄影摄像已点击确定</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt class="w150">部分派发:</dt>
                                    <dd>派发某摄影师/化妆师/司仪/摄影摄像已点击确定</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt class="w150">已完成:</dt>
                                    <dd>派发某摄影师/化妆师/司仪/摄影摄像已点击确定</dd>
                                </dl>
                            </div>
                        </div>
                        <el-button slot="reference" class="ml8" type="danger">注解</el-button>
                    </el-popover>
                </div>
            </div>
        </div>
        <el-table :data="tableData" border :height="tableHeight" :max-height="tableHeight" v-loading="loading">
            <el-table-column prop="status" label="派单状态" align="center">
                <template slot-scope="scope">
                    <el-link type="danger" @click="showDrawerPass(_self, 'detailView', 'showDrawer', [scope.row])" v-if="scope.row.status == 0">待派发</el-link>
                    <el-link type="danger" @click="showDrawerPass(_self, 'detailView', 'showDrawer', [scope.row])" v-if="scope.row.status == 1">部分派发</el-link>
                    <el-link type="danger" @click="showDrawerPass(_self, 'detailView', 'showDrawer', [scope.row])" v-if="scope.row.status == 2">已完成</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="planner" label="策划师"></el-table-column>
            <el-table-column prop="service.title" label="执行公司" show-overflow-tooltip></el-table-column>
            <el-table-column prop="order.event_date" label="婚期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="order.hotel" label="酒店" show-overflow-tooltip></el-table-column>
            <el-table-column prop="hall" label="厅" show-overflow-tooltip></el-table-column>
            <el-table-column prop="order.bridegroom" label="客户姓名"></el-table-column>

            <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
        </el-table>
        <!-- 底部操作栏 -->
        <div class="footer-box">
            <div class="download"></div>
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[15, 20, 50, 100]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.totals"></el-pagination>
            </div>
        </div>
        <detail-view ref="detailView" :parent="_self"></detail-view>
    </div>
</template>

<script>
import {
    showDrawerPass
} from '@/utils/common.js';
import dictionary from '@/utils/dictionary';
import detailView from './demand/detail.vue';
const query = {
    news_type: "1",
    type: "project",
    company_id: "",
    hotel_id: "",
    planer_id: "",
    date_range: [],
    keywords: "", //手机号/客户姓名/微信号
    status: ''
};
export default {
    namespace: true,
    name: "ProjectMineTask",
    components: {
        detailView
    },
    data() {
        let tableHeight = window.innerHeight - 300;
        let windowheight = window.innerHeight;
        return {
            plannerList: [],
            query: Object.assign({}, query), // 搜索条件
            tableData: [],
            tableHeight: tableHeight,
            windowheight: windowheight,
            pagination: {
                page: 1,
                limit: 15,
                totals: 0
            },
            loading: false,
            statusList: [{
                id: 0,
                title: "待分配"
            }, {
                id: 1,
                title: '部分分配'
            }, {
                id: 2,
                title: '已完成'
            }],
        };
    },
    computed: {
        planNewsTypeList() {
            let planList = [{
                id: "1",
                title: "婚庆信息"
            },
            {
                id: "7",
                title: "宝宝宴"
            },
            {
                id: "8",
                title: "会务"
            },
            {
                id: "11",
                title: "婚博会"
            },
            {
                id: "12",
                title: "婚礼秀"
            }
            ];

            return planList;
        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.dictionary = dictionary;
    },
    created() {
        this.getTableData();
        this.getPlannerList();
    },
    methods: {
        getTableData() {
            let _this = this;
            _this.loading = true;
            let url = '/api/wedding.demand/index';
            let query = this.query;
            query.pagination = _this.pagination;
            this.$post(url, query).then(res => {
                let resData = res.data;
                _this.tableData = resData.list;
                _this.pagination = resData.pagination;
                _this.loading = false
            });
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        changeHandler() {
            this.pagination.page = 1;
            this.getTableData();
        },
        getPlannerList() {
            let _this = this;
            let url = '/api/ucenter.user/roleUserList';
            let params = {
                role_id: [32, 35]
            };
            _this.$post(url, params).then((res) => {
                _this.plannerList = res.data.list;
            });
        }
    }
}
</script>

<style lang="less">
@import url('@/assets/css/common.less');
</style>
